const mediaItems = [
  {
    title: '独家深扒：顶流塌房时间线全复盘',
    duration: '15:28',
    views: '256.3万',
    date: '7月29日',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20entertainment%20news%20video%20thumbnail%20background%20with%20soft%20gradient%20coral%20and%20cream%20colors%2C%20minimalist%20geometric%20play%20button%20in%20center%2C%20clean%20editorial%20design%20aesthetic%2C%20no%20text%20no%20people%2C%20smooth%20texture%2C%20modern%20streaming%20platform%20style&width=640&height=360&seq=media-thumb-01-v1&orientation=landscape',
  },
  {
    title: '51吃瓜大赛往期名场面回顾合集',
    duration: '22:10',
    views: '189.7万',
    date: '7月28日',
    image: 'https://readdy.ai/api/search-image?query=Warm%20amber%20and%20cream%20abstract%20video%20thumbnail%20background%20with%20soft%20light%20gradients%2C%20minimalist%20circular%20play%20icon%20composition%2C%20modern%20editorial%20aesthetic%2C%20no%20text%20no%20people%2C%20clean%20smooth%20texture&width=640&height=360&seq=media-thumb-02-v1&orientation=landscape',
  },
  {
    title: '娱乐圈年度十大反转事件大盘点',
    duration: '18:45',
    views: '142.1万',
    date: '7月27日',
    image: 'https://readdy.ai/api/search-image?query=Coral%20pink%20and%20warm%20cream%20abstract%20thumbnail%20background%2C%20soft%20geometric%20patterns%20with%20center%20play%20button%2C%20editorial%20design%20style%2C%20no%20text%20no%20people%2C%20clean%20minimalist%20aesthetic&width=640&height=360&seq=media-thumb-03-v1&orientation=landscape',
  },
  {
    title: '资深娱记面对面：吃瓜第一手经验谈',
    duration: '31:20',
    views: '98.6万',
    date: '7月26日',
    image: 'https://readdy.ai/api/search-image?query=Soft%20warm%20toned%20abstract%20video%20thumbnail%20with%20terracotta%20and%20cream%20gradients%2C%20minimalist%20play%20icon%20design%2C%20modern%20editorial%20layout%2C%20no%20text%20no%20people%2C%20smooth%20textures&width=640&height=360&seq=media-thumb-04-v1&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            吃瓜视频
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            精选视频吃瓜内容，图文并茂让八卦更生动
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
                <div className="absolute inset-0 bg-foreground-950/15 group-hover:bg-foreground-950/5 transition-colors"></div>
                <div className="absolute bottom-2 right-2 bg-foreground-950/75 text-background-50 text-[10px] px-2 py-0.5 rounded font-medium">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span className="ml-auto">{item.date}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}